// Imports
import { Base, DataTypes, SubmitTypes, ErrorTypes } from '@mixins/forms'
import HsiaLoginMixin from '@mixins/hsia-login-mixin'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { AjaxSubmit: submitType } = SubmitTypes
const { ProblemDetailsError: errorHandling } = ErrorTypes

// Options
const options = {
  name: 'fmo:resetpassword',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: true,
    validation: true,
    submit: { events: { resetpassword: true } },
    error: true
  }
}

// Component
export default {
  name: 'reset-form',
  mixins: [
    Base(options),
    HsiaLoginMixin
  ],
  data: () => ({
    completed: false
  }),
  computed: {
    innerScope() {
      return {
        completed: this.completed
      }
    }
  },
  mounted() {
    if (this.isSitecore) {
      this.createSitecoreExpSwitcher()
    }
  },
  methods: {
    /**
    * Sets the completed template cta to be shownd
    */
    async transformResponse(response) {
      this.completed = true
      return response
    },
    createSitecoreExpSwitcher() {
      const button = document.createElement('button')
      const text = document.createTextNode('see result')
      button.appendChild(text)
      button.classList.add('switch-state')
      button.addEventListener('click', () => {
        this.completed = !this.completed
        if (this.completed) {
          button.innerText = 'see form'
        } else {
          button.innerText = 'see result'
        }
      })
      this.$el.appendChild(button)
    },
  }
}